

import { Champignons, Espece, Nuisible } from '@repo/types';
import { Field } from '../../../shared/types';

export interface DynamicFieldOptionsProps {
  field: Field;
  champignons: Champignons[];
  especes: Espece[];
  nuisibles: Nuisible[];
}

/**
 * Transforms inventory data into field options based on field type
 */
export function getDynamicFieldOptions(
  field: Field,
  champignons: Champignons[],
  especes: Espece[],
  nuisibles: Nuisible[]
): Field['options'] {
  // If field already has options, return them
  if (field.options && field.options.length > 0) {
    return field.options;
  }

  // Map field names to their corresponding data
  const fieldName = field.name.toLowerCase();

  // Champignons fields
  if (fieldName.includes('champignon') || fieldName.includes('champignons')) {
    return champignons.map(champignon => ({
      id: champignon.id?.toString() || '',
      label: champignon.name || 'Sans nom'
    }));
  }

  // Especes fields
  if (fieldName.includes('espece') || fieldName.includes('especes') || fieldName.includes('espèce') || fieldName.includes('espèces')) {
    return especes.map(espece => ({
      id: espece.id?.toString() || '',
      label: espece.nom_fr || espece.name || 'Sans nom'
    }));
  }

  // Nuisibles fields
  if (fieldName.includes('nuisible') || fieldName.includes('nuisibles') || fieldName.includes('parasite')) {
    return nuisibles.map(nuisible => ({
      id: nuisible.id?.toString() || '',
      label: nuisible.name || 'Sans nom'
    }));
  }

  // Return empty array if no match
  return [];
}

/**
 * Hook to get dynamic field options
 */
export function useDynamicFieldOptions(
  field: Field,
  champignons: Champignons[],
  especes: Espece[],
  nuisibles: Nuisible[]
) {
  return getDynamicFieldOptions(field, champignons, especes, nuisibles);
}
